import { Controller } from "@hotwired/stimulus"

// Inicializa el audio player de Mediastream Lightning Player.
// Reintenta automaticamente si Mediastream aun no tiene el media disponible
// (retorna 404 los primeros minutos despues de subir).
//
// Estrategia de reintentos: 10s, 15s, 20s, 30s, 30s... (max 10 intentos = ~4 min)
//
// Uso:
//   <div data-controller="manage--ms-audio-player"
//        data-manage--ms-audio-player-media-id-value="abc123"
//        data-manage--ms-audio-player-token-value="token">
//   </div>
export default class extends Controller {
  static values = {
    mediaId: String,
    token: String,
  }

  connect() {
    this._retryCount = 0
    this._maxRetries = 10
    this._retryTimer = null
    this.elementId = `ms-player-${this.mediaIdValue}`
    this.element.id = this.elementId
    this.element.textContent = "Cargando player..."
    this.loadScript()
  }

  disconnect() {
    if (this._retryTimer) {
      clearTimeout(this._retryTimer)
      this._retryTimer = null
    }
  }

  loadScript() {
    if (window.loadMSPlayer) {
      this.initPlayer()
    } else {
      if (!document.querySelector('script[src*="lightning_player"]')) {
        const script = document.createElement("script")
        script.src = "https://player.cdn.mdstrm.com/lightning_player/api.js"
        script.crossOrigin = "anonymous"
        script.onload = () => this.initPlayer()
        script.onerror = () => this.scheduleRetry()
        document.head.appendChild(script)
      } else {
        setTimeout(() => this.loadScript(), 300)
      }
    }
  }

  initPlayer() {
    if (!window.loadMSPlayer) return
    window.loadMSPlayer(this.elementId, {
      type: "media",
      id: this.mediaIdValue,
      volume: 100,
      appName: "flycrew",
      accessToken: this.tokenValue,
      player: "61bbbc6edee46728236c9173",
      renderAs: "video",
    }).catch((err) => {
      console.warn("[ms-audio-player] Mediastream no disponible aun, reintentando...", err.message || err)
      this.scheduleRetry()
    })
  }

  scheduleRetry() {
    this._retryCount++
    if (this._retryCount > this._maxRetries) {
      this.element.textContent = "No se pudo cargar el player. Recarga la pagina."
      return
    }

    const delay = Math.min(10000 + (this._retryCount - 1) * 5000, 30000)

    this._retryTimer = setTimeout(() => {
      // Limpiar el elemento para que loadMSPlayer pueda reinicializarlo
      this.element.innerHTML = ""
      this.element.id = this.elementId
      this.initPlayer()
    }, delay)
  }
}
